import Vue from 'vue';
let id = 0;

const toastBus = new Vue({ name: 'ToastBus' });

const generateId = () => {
  return id++;
};
export { toastBus, generateId };
